interface CarouselDescriptor
{
	id: string;
}

interface CarouselItemDescriptor
{
	src: string;
	alt: string;
}

class Carousel
{
	protected element: HTMLElement;
	protected id: string;
	protected count: number;

	constructor(descriptor: CarouselDescriptor)
	{
		this.element = document.createElement( 'div' );
		const tempOL = document.createElement( 'ol' );
		const tempInner = document.createElement( 'div' );
		let tempA = document.createElement( 'a' );
		let tempSpan = document.createElement( 'span' );

		this.count = 0;
		this.id = descriptor.id;

		$( this.element ).attr( 'id', this.id);
		$( this.element ).addClass( 'carousel slide' );
		$( this.element ).attr( 'data-ride', 'carousel');

		$( tempOL ).attr( 'id', this.id + '-OL');
		$( tempOL ).addClass( 'carousel-indicators' );
		$( this.element ).append( tempOL );

		$( tempInner ).addClass( 'carousel-inner' );
		$( tempInner ).attr( 'id', this.id + '-Inner');
		$( tempInner ).attr( 'role', 'listbox' );
		$( this.element ).append( tempInner );

		// linke Steuerung
		$( tempA ).addClass( 'left carousel-control' );
		$( tempA ).attr( 'href', '#' + descriptor.id );
		$( tempA ).attr( 'role', 'button' );
		$( tempA ).attr( 'data-slide', 'prev' );

		$( tempSpan ).addClass( 'glyphicon glyphicon-chevron-left');

		$( tempA ).append( tempSpan );
		$( this.element ).append( tempA );

		// rechte Steuerung
		tempA = document.createElement( 'a' );
		tempSpan = document.createElement( 'span' );
		$( tempA ).addClass( 'right carousel-control' );
		$( tempA ).attr( 'href', '#' + descriptor.id );
		$( tempA ).attr( 'role', 'button' );
		$( tempA ).attr( 'data-slide', 'next' );

		$( tempSpan ).addClass( 'glyphicon glyphicon-chevron-right');

		$( tempA ).append( tempSpan );
		$( this.element ).append( tempA );

	}

	public addItem( descriptor: CarouselItemDescriptor )
	{
		const tempItem = document.createElement( 'div' );
		const tempImg = document.createElement( 'img' );
		const tempLI = document.createElement( 'li' );

		$( tempItem ).addClass( 'item' );

		if ( this.count == 0)
		{
				$( tempItem ).addClass( 'active' );
		}
		$( tempImg ).attr( 'src', descriptor.src );
		$( tempImg ).attr( 'alt', descriptor.alt );

		$( tempItem ).append( tempImg );

		$( '#' + this.id + '-Inner' ).append( tempItem );

		// li-Elemente dem ol hinzufügen
		$( tempLI ).attr( 'data-target', '#' + this.id );
		$( tempLI ).attr( 'data-slide-to', this.count );

		if ( this.count == 0)
		{
			$( tempLI ).addClass( 'active' );
		}

		$( '#' + this.id + '-OL' ).append( tempLI );
		++this.count;
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

}
